import { useContext, useEffect, useCallback, DependencyList } from 'react';
import { DatafeedContext } from '.';

type AuthCallback = (socket: WebSocket) => void;

type UseDatafeedAuthEffect = (
  callback: AuthCallback,
  deps: DependencyList,
) => void;

const useDatafeedAuthEffect: UseDatafeedAuthEffect = (callback, deps) => {
  const { socket, isAuthorized } = useContext(DatafeedContext);
  const handleCallback = useCallback(callback, deps);

  useEffect(() => {
    if (isAuthorized) handleCallback(socket);
  }, [isAuthorized, handleCallback]);
};

export default useDatafeedAuthEffect;
